import { render, staticRenderFns } from "./Jivosite.vue?vue&type=template&id=72f2fbe1&"
import script from "./Jivosite.vue?vue&type=script&lang=js&"
export * from "./Jivosite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports